import { Col, Row } from "react-bootstrap";
import KSelect from "../../../../utilsComponent/KSelect";
import KInputField from "../../../../utilsComponent/KInputField";
import KDatePicker from "../../../../utilsComponent/KDatePicker";
import { useEffect, useState } from "react";
import {
  attachmentAvailabilityOptions,
  claimPendingActions,
} from "../../../../consts";

import {
  getAssignTo,
  getClaimStatus,
  getClaimSubStatus,
  getDistrictList,
  getMandalList,
  getPolicyStatusOptions,
  getRoles,
  getStatesList,
  getVillageList,
} from "../Service/apiHelper";
import {
  generateYears,
  getFromDecreaptLocalStorage,
} from "../../../../utilFunctions";
import { toast } from "react-toastify";
import { differenceInDays, subDays } from "date-fns";
const defaultFilerValue = {
  assignedTo: "",
  remark: "",
  role: "",
  seasonName: "",
  seasonYear: "",
  claimStatus: "",
  toDate: "",
  fromDate: "",
  claimSubStatus: "",
  claimId: "",
  policyId: "",
  customerId: "",
  memberId:"",
  mobileNumber:"",
  pendingActions: "",
  productName: "",
  state: null,
  district: null,
  mandal: null,
  village: null,
  claimIngestionType: "",
  peril: "",
  crop: "",
  calamityType: "",
  policyStatus: "",
  vendorName: "",
  surveyorName: "",
  email: "",
  isAttachmentAvailable: "",
  isPotentialLitigation:""
};

const ClaimFilter = (props) => {
  const { productNames } = props;
  const [filterValue, setFilterValue] = useState(defaultFilerValue);
  const [statesList, setStatesList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [mandalList, setMandalList] = useState([]);
  const [villageList, setVillageList] = useState([]);
  const [claimRoles, setClaimRoles] = useState([]);
  const [assignedToList, setAssignedToList] = useState([]);
  const [claimStatusList, setClaimStatusList] = useState([]);
  const [claimSubStatusList, setClaimSubStatusList] = useState([]);
  const [isViewMore, setIsViewMore] = useState(false);
  const [policyStatusOptions, setPolicyStatusOptions] = useState("");
  const [yearOption, setYearOption] = useState([]);

  useEffect(() => {
    getClaimStatus(setClaimStatusList);
    getClaimSubStatus(setClaimSubStatusList)
    getPolicyStatusOptions(setPolicyStatusOptions);
    setYearOption(generateYears(2010));
    getAssignTo(setAssignedToList);
    getRoles(setClaimRoles);
    getStatesList(setStatesList);
    if (productNames?.length > 0) {
      setFilterValue((prev) => ({
        ...prev,
        productName: productNames[0],
      }));
    }
  }, []);

  const onFilterChange = (name, value) => {
    setFilterValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateFilter = () => {
    if (Object.values(filterValue).every((val) => val === "" || val === null)) {
      toast.error("Please select at least one filter to search");
    } else if (filterValue.fromDate && filterValue.toDate && differenceInDays(filterValue.fromDate, filterValue.toDate) > 0) {
      toast.error("From Date should be less than To Date");
    } else {
      props.onSearch(filterValue);
    }
  };

  return (
    <div className="border rounded ps-4 pt-4 pb-4">
      <Row>
        <Col>
          <KSelect
            options={props.productNames}
            value={filterValue.productName || ""}
            label="Product Name"
            placeholder="Select Product Name"
            onChange={(data) => {
              onFilterChange("productName", data);
            }}
          />
        </Col>

        <Col>
          <KSelect
            options={claimStatusList}
            value={filterValue.claimStatus}
            label="Claim Status"
            placeholder="Select Claim Status"
            onChange={(data) => {
              onFilterChange("claimStatus", data);
            }}
          />
        </Col>
        <Col>
          <KSelect
            options={claimSubStatusList}
            value={filterValue.claimSubStatus}
            label="Claim Sub-Status"
            placeholder="Select Claim Sub-Status"
            onChange={(data) => {
              onFilterChange("claimSubStatus", data);
            }}
          />
        </Col>
        <Col>
          <KInputField
            value={filterValue.claimId}
            label="Claim ID"
            placeholder="Enter Claim ID"
            onChange={(data) => {
              onFilterChange("claimId", data);
            }}
          />
        </Col>

        {/* <Col xs={12} md={3}>
          <KSelect
            options={policyStatusOptions}
            value={filterValue.policyStatus}
            label="Policy Status"
            placeholder="Select Policy Status"
            onChange={(data) => {
              onFilterChange("policyStatus", data);
            }}
          />
        </Col> */}
      </Row>
      <Row className="mt-3">
        <Col xs={12} md={3}>
          <KInputField
            value={filterValue.policyId}
            label="Policy ID"
            placeholder="Enter Policy ID"
            onChange={(data) => {
              onFilterChange("policyId", data);
            }}
          />
        </Col>
        <Col xs={12} md={3}>
          <KInputField
            value={filterValue.customerId}
            label="Customer ID"
            placeholder="Enter Customer ID"
            onChange={(data) => {
              onFilterChange("customerId", data);
            }}
          />
        </Col>
        <Col xs={12} md={3}>
          <KInputField
            value={filterValue.memberId}
            label="Member ID"
            placeholder="Enter Member ID"
            onChange={(data) => {
              onFilterChange("memberId", data);
            }}
          />
        </Col>
        <Col xs={12} md={3}>
          <KInputField
            value={filterValue.mobileNumber}
            label="Mobile Number"
            placeholder="Enter Mobile Number"
            onChange={(data) => {
              onFilterChange("mobileNumber", data);
            }}
          />
        </Col>
      </Row>
      <Row className="mt-3">

        <Col xs={12} md={3}>
          <KSelect
            options={attachmentAvailabilityOptions}
            value={filterValue.isAttachmentAvailable}
            label="Attachment Availability"
            placeholder="Select Availability"
            onChange={(data) => {
              onFilterChange("isAttachmentAvailable", data);
            }}
          />
        </Col>


        <Col xs={12} md={3} className="col-style">
          <Row className="row-style">
            <Col xs={6} md={6} className="col-style">
              <KDatePicker
                placeholder="From Date"
                label="Intimation Date"
                labelClass="single-line-text"
                value={filterValue.fromDate}
                maxDate={new Date()}
                onChange={(date) => {
                  onFilterChange("fromDate", date);
                }}
              />
            </Col>
            <Col xs={6} md={6} className="col-style">
              <KDatePicker
                placeholder="To Date"
                label="--"
                labelClass="single-line-text labelClass"
                value={filterValue.toDate}
                maxDate={new Date()}
                onChange={(date) => {
                  onFilterChange("toDate", date);
                }}
              />
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={3}>
          <KSelect
            options={claimRoles}
            value={filterValue.role}
            label="Role"
            placeholder="Select Role"
            onChange={(data) => {
              onFilterChange("role", data);
            }}
          />
        </Col>
      </Row>


      {isViewMore && (
        <>
          <Row className="mt-3">
            <Col xs={12} md={3}>
              <KSelect
                options={statesList}
                value={filterValue.state}
                label="State"
                placeholder="Select State"
                onChange={(data) => {
                  if (data && data.value) {
                    getDistrictList(data?.label, setDistrictList);
                  }
                  setFilterValue({
                    ...filterValue,
                    state: data,
                    district: null,
                    mandal: null,
                    village: null,
                  });
                  if (!data) {
                    setDistrictList([]);
                    setMandalList([]);
                    setVillageList([]);
                  }
                }}
              />
            </Col>
            <Col xs={12} md={3}>
              <KSelect
                options={districtList}
                value={filterValue.district}
                label="District"
                placeholder="Select District"
                isDisabled={!filterValue?.state}
                onChange={(data) => {
                  if (data?.value) {
                    getMandalList(
                      filterValue?.state?.label,
                      data?.label,
                      setMandalList
                    );
                  }
                  setFilterValue({
                    ...filterValue,
                    district: data,
                    mandal: null,
                    village: null,
                  });
                  if (!data) {
                    setMandalList([]);
                    setVillageList([]);
                  }
                }}
              />
            </Col>
            <Col xs={12} md={3}>
              <KSelect
                options={mandalList}
                value={filterValue.mandal}
                label="Mandal"
                placeholder="Select Mandal"
                isDisabled={!filterValue.district}
                onChange={(data) => {
                  if (data?.value) {
                    getVillageList(
                      filterValue.state?.label,
                      filterValue.district?.label,
                      data?.label,
                      setVillageList
                    );
                  }
                  setFilterValue({
                    ...filterValue,
                    mandal: data,
                    village: null,
                  });
                  if (!data) {
                    setVillageList([]);
                  }
                }}
              />
            </Col>
            <Col xs={12} md={3}>
              <KSelect
                options={villageList}
                value={filterValue.village}
                label="Village"
                placeholder="Select Village"
                isDisabled={!filterValue.mandal}
                onChange={(data) => {
                  onFilterChange("village", data);
                }}
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col xs={12} md={3}>
              <KSelect
                options={assignedToList}
                value={filterValue.assignedTo}
                label="Remarks & Request Assigned Team"
                placeholder="Select Team"
                onChange={(data) => {
                  onFilterChange("assignedTo", data);
                }}
              />
            </Col>
            <Col xs={12} md={3}>
              <KSelect
                options={assignedToList}
                value={filterValue.remark}
                label="Remarks & Request Email"
                placeholder="Select Email"
                onChange={(data) => {
                  onFilterChange("remark", data);
                }}
              />
            </Col>

            <Col xs={12} md={3}>
              <KSelect
                options={claimPendingActions}
                value={filterValue.pendingActions}
                label="Pending Action"
                placeholder="Select Pending Action"
                onChange={(data) => {
                  onFilterChange("pendingActions", data);
                }}
              />
            </Col>
            <Col xs={12} md={3}>
              <KSelect
                options={[]}
                value={filterValue.flaggedClaim}
                label="Flagged Claims"
                placeholder="Select Flag Status"
                onChange={(data) => {
                  onFilterChange("flaggedClaim", data);
                }}
              />
            </Col>
          </Row>


          {/* <Row className="mt-3">
            
          </Row> */}
        </>
      )}

      <Row>
        <Col xs={12} md={9}>
          <button
            className="btn btn-success mt-4 mb-0 px-4"
            onClick={() => {
              validateFilter();
            }}
          >
            Search
          </button>

          <div
            className="btn btn-outline-success mt-4 ms-4 mb-0 px-4"
            onClick={() => {
              setFilterValue({ ...filterValue, ...defaultFilerValue });
              props.onReset();
            }}
          >
            Reset
          </div>
        </Col>

        <Col xs={12} md={3} className="col-style text-end">
          <div className="d-md-inline-flex align-items-center mt-4 me-3">
            <div
              className="view-more-button"
              onClick={() => setIsViewMore(!isViewMore)}
            >
              {isViewMore ? "- View Less" : " + View More"}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ClaimFilter;
